module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseReport
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Generate Report")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_vm._v("\n    report\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82b69ec8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/log-report.vue
// module id = 595
// module chunks = 4 5 6